export const statisticsInfoStyle = {
	wrapper: {
		marginBottom: '16px',
	},

	content: {
		display: 'flex',
		gap: '16px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '1170px',
			width: '100%',
			height: '100%',
			padding: '48px 38px 0 48px',
			scrollbarGutter: 'stable',

			'& .MuiButtonBase-root': {
				right: '0',
			},

			'& .MuiDialogTitle-root': {
				marginBottom: '40px',
			},

			'& > div': {
				height: '100%',

				'& > div': {
					height: '100%',
					display: 'flex',
					justifyContent: 'flex-start',
				},
			},
		},
	},
};
